export const PRACTICE_AREAS = {
  "corporate": {
    "eyebrow": "Chambers Ranked · Legal 500 Ranked · Vietnam",
    "titleFirst": "Corporate",
    "titleEm": "M&A",
    "sub": "End-to-end advisory on corporate establishment, mergers and acquisitions, joint ventures, and FDI structuring. Ranked by Chambers Asia-Pacific and Legal 500 as a leading Vietnamese law firm in Corporate and M&A.",
    "tags": [
      "Corporate Establishment",
      "FDI & Licensing",
      "Mergers & Acquisitions",
      "Legal Due Diligence",
      "Joint Ventures",
      "Private Equity"
    ],
    "services": [
      {
        "name": "Incorporation & Licensing",
        "desc": "Assisting foreign investors in establishing their legal presence in Vietnam — representative offices, wholly foreign-owned companies, joint ventures, and business cooperation contracts — including investment and business registration certificates."
      },
      {
        "name": "Corporate Governance",
        "desc": "Advising on corporate structuring, governance frameworks, company charters, board resolutions, and statutory compliance. We support boards and management teams on corporate housekeeping and ongoing secretarial obligations."
      },
      {
        "name": "M&A Advisory",
        "desc": "Acting as lead counsel for buyers and sellers on domestic and cross-border M&A transactions — from initial structuring through signing and closing. We draft and negotiate all transaction documents including SPAs and BTAs."
      },
      {
        "name": "Legal Due Diligence",
        "desc": "Conducting comprehensive legal due diligence on Vietnamese targets — covering corporate, regulatory, employment, real estate, and tax matters. We provide clear, risk-ranked reports that drive deal decisions."
      },
      {
        "name": "Joint Ventures",
        "desc": "Structuring and documenting joint ventures between foreign and Vietnamese parties, including governance arrangements, deadlock mechanisms, exit provisions, and ongoing compliance with Vietnam’s Investment Law."
      },
      {
        "name": "Private Equity & Funds",
        "desc": "Advising private equity investors, venture capital funds, and financial institutions on investments into Vietnamese companies — from structuring and due diligence through closing and post-investment governance."
      }
    ],
    "engagements": [
      {
        "num": "01",
        "tag": "Nippon Steel / BlueScope Steel — USD 1.36 Billion JV",
        "text": "Performed comprehensive due diligence and advised on Vietnam aspects for Nippon Steel’s acquisition of BlueScope Steel businesses as part of a USD 1.36 billion joint venture. One of the largest inbound manufacturing investments in Vietnam at the time."
      },
      {
        "num": "02",
        "tag": "Merck / ScheringPlough — USD 41.1 Billion Global Merger",
        "text": "Acted for Merck on the Vietnam aspects of the global Merck/ScheringPlough merger valued at USD 41.1 billion — coordinating with the global deal team and managing all local regulatory filings and approvals."
      },
      {
        "num": "03",
        "tag": "Tencent / VNG Corporation",
        "text": "Acted for Tencent in its acquisition of a minority interest in VNG Corporation (commonly known as Vinagames) — one of Vietnam’s first major technology sector cross-border investments."
      },
      {
        "num": "04",
        "tag": "JA Solar — USD 240M+ Greenfield Factory",
        "text": "Advised on the establishment of a Vietnamese subsidiary for JA Solar (one of the world’s largest manufacturers of solar cells and modules) for manufacturing operations in Bac Giang Province. Total investment exceeding VND 5,000 billion (~USD 240M) required the Prime Minister’s approval."
      },
      {
        "num": "05",
        "tag": "Union Underwear (Fruit of the Loom) — Thanh Hoa Factory",
        "text": "Advised on the establishment of a Vietnamese subsidiary for Union Underwear (holding company for the Fruit of the Loom group) for manufacturing operations in Thanh Hoa Province, including advising on factory land acquisition and construction agreements."
      },
      {
        "num": "06",
        "tag": "Rocket Internet — Lazada & Zalora Vietnam Entities",
        "text": "Incorporated the Vietnam operational entities for Rocket Internet’s Lazada and Zalora businesses — two of Southeast Asia’s most significant early-stage e-commerce ventures, now among the region’s largest online retailers."
      }
    ],
    "why": [
      {
        "num": "01",
        "title": "Consistently Ranked",
        "desc": "Ranked by Chambers Asia-Pacific in Corporate & M&A every year since 2022, and by Legal 500 every year since 2020 — demonstrating a sustained track record of high-quality M&A and corporate work."
      },
      {
        "num": "02",
        "title": "Transaction Experience",
        "desc": "Our partners have led transactions valued in the tens of billions of USD — from billion-dollar joint ventures and global mergers to greenfield factory establishments requiring Prime Minister approval."
      },
      {
        "num": "03",
        "title": "Boutique Quality, International Standard",
        "desc": "Both partners bring extensive international law firm experience, delivering the rigour and quality of a top-tier firm with the responsiveness, personal service, and competitive rates of a focused boutique."
      }
    ],
    "industries": [
      "Manufacturing & Industrial",
      "Garments & Footwear",
      "Pharmaceuticals",
      "FMCG & Consumer Goods",
      "Insurance & Financial Services",
      "Technology & E-commerce",
      "Logistics & Supply Chain",
      "Renewable Energy",
      "Automotive"
    ],
    "team": [
      {
        "slug": "diep",
        "name": "Dee (Diep) Hoang",
        "title": "Founder & Partner"
      },
      {
        "slug": "michael",
        "name": "Michael Lee",
        "title": "Partner"
      },
      {
        "slug": "helen",
        "name": "Helen (Trang) Nguyen",
        "title": "Partner"
      }
    ],
    "related": [
      {
        "slug": "licensing",
        "name": "Licensing & Regulatory",
        "desc": "Government approvals, sector licensing, and ongoing regulatory compliance."
      },
      {
        "slug": "realestate",
        "name": "Real Estate",
        "desc": "Land use rights, industrial zone acquisitions, and property transactions."
      },
      {
        "slug": "labour",
        "name": "Labour & Employment",
        "desc": "Employment structuring for new market entrants and post-acquisition workforces."
      }
    ],
    "cta": {
      "titlePre": "Discuss your corporate",
      "titleEm": "or M&A matter",
      "sub": "Our partners are available for a confidential discussion about your transaction or Vietnam investment.",
      "btns": [
        {
          "cls": "btn-gold2",
          "page": "contact",
          "text": "Contact Our Team"
        },
        {
          "cls": "btn-outline",
          "page": "team",
          "text": "Meet the Partners"
        }
      ]
    }
  },
  "licensing": {
    "eyebrow": "Advisory · Government Relations · Vietnam",
    "titleFirst": "Licensing &",
    "titleEm": "Regulatory",
    "sub": "We act as trusted counsel to our clients, helping them navigate an increasingly complex Vietnam regulatory environment — from sector-specific licensing to competition law, pharmaceutical regulation, and government investigations.",
    "tags": [
      "Competition & Anti-trust",
      "Government Investigations",
      "Sector Licensing",
      "Pharmaceutical Regulation",
      "Compliance Programmes",
      "Crisis Management"
    ],
    "services": [
      {
        "name": "Regulatory Licensing",
        "desc": "Obtaining sector-specific licences and approvals for foreign-invested enterprises operating in regulated industries, including pharmaceuticals, insurance, banking, telecommunications, e-commerce, and automotive distribution."
      },
      {
        "name": "Competition & Anti-trust",
        "desc": "Advising on Vietnam’s competition law framework, including merger control filings, anti-competitive conduct assessments, cartel investigations, and representation before the Vietnam Competition Commission (VCC)."
      },
      {
        "name": "Government Investigations",
        "desc": "Representing clients in government investigations and regulatory proceedings across tax, customs, environment, labour, and sector-specific regulators — providing strategic crisis management advice and managing government relations."
      },
      {
        "name": "Pharmaceutical Regulation",
        "desc": "Advising on pharmaceutical licensing, drug registration, clinical trial approvals, import permits, and distribution arrangements — drawing on deep experience in Vietnam’s healthcare regulatory environment."
      },
      {
        "name": "Compliance Programmes",
        "desc": "Designing and implementing compliance programmes for multinational clients operating in Vietnam, covering anti-bribery and anti-corruption, competition law, data privacy, and sector-specific regulatory obligations."
      },
      {
        "name": "Regulatory Due Diligence",
        "desc": "Conducting targeted regulatory due diligence for M&A transactions, identifying licence gaps, pending investigations, and regulatory risk — and advising on remediation strategies as part of transaction structuring."
      }
    ],
    "engagements": [
      {
        "num": "01",
        "tag": "Ferrari Dealership — Multi-Licence Approval",
        "text": "Obtained foreign investment approval and incorporated a Korean multinational’s subsidiary to operate a Ferrari dealership in Vietnam. Obtained car import licence and warranty and maintenance licence — a complex multi-agency approval process."
      },
      {
        "num": "02",
        "tag": "Merck Sharp & Dohme — Pharmaceutical Subsidiary",
        "text": "Incorporated a Vietnamese subsidiary for Merck Sharp & Dohme to engage in the import of pharmaceutical products — navigating Vietnam’s complex pharmaceutical licensing requirements for multinational drug companies."
      },
      {
        "num": "03",
        "tag": "Anti-Corruption Training — Leading MNC Clients",
        "text": "Conducted compliance and anti-corruption training for numerous leading multinational companies operating in Vietnam, including presentations on Vietnam’s Penal Code provisions and sector-specific compliance risks."
      },
      {
        "num": "04",
        "tag": "Environmental Regulatory Investigation",
        "text": "Advised a Taiwanese multinational during one of Vietnam’s most significant environmental enforcement actions, managing regulatory filings, government liaison, and crisis communications across multiple Vietnamese regulatory agencies simultaneously."
      },
      {
        "num": "05",
        "tag": "10-Year Tax Audit — Manufacturing MNC",
        "text": "Advised a multinational Taiwanese manufacturer on a high-profile tax audit covering ten years of records. The client employed over 5,000 workers with yearly exports approaching USD 100 million. Managed the regulatory process and negotiated the outcome with tax authorities."
      }
    ],
    "why": [
      {
        "num": "01",
        "title": "Government Relations",
        "desc": "Our team maintains strong working relationships with Vietnamese regulatory agencies across MPI, MOH, MOFA, MOF, and sector regulators — enabling us to navigate approvals efficiently and manage regulatory risk proactively."
      },
      {
        "num": "02",
        "title": "Crisis Experience",
        "desc": "We have represented clients in some of Vietnam’s most high-profile regulatory investigations — including environmental enforcement actions and decade-long tax audits — providing strategic advice under pressure."
      },
      {
        "num": "03",
        "title": "Sector Breadth",
        "desc": "Our regulatory experience spans pharmaceuticals, automotive, insurance, e-commerce, logistics, manufacturing, and financial services — giving us the sector depth to advise on the most complex licensing challenges."
      }
    ],
    "industries": [
      "Pharmaceuticals & Healthcare",
      "Insurance & Financial Services",
      "Automotive",
      "FMCG & Consumer Goods",
      "E-commerce & Technology",
      "Logistics & Supply Chain",
      "Manufacturing",
      "Telecommunications"
    ],
    "team": [
      {
        "slug": "diep",
        "name": "Dee (Diep) Hoang",
        "title": "Founder & Partner"
      },
      {
        "slug": "michael",
        "name": "Michael Lee",
        "title": "Partner"
      },
      {
        "slug": "helen",
        "name": "Helen (Trang) Nguyen",
        "title": "Partner"
      }
    ],
    "related": [
      {
        "slug": "corporate",
        "name": "Corporate M&A",
        "desc": "Incorporation, FDI structuring, and post-licensing corporate governance."
      },
      {
        "slug": "privacy",
        "name": "Data Privacy",
        "desc": "Decree 13/2023 compliance, DPIA filing, and data protection programmes."
      },
      {
        "slug": "disputes",
        "name": "Disputes",
        "desc": "Government investigations, tax disputes, and regulatory enforcement defence."
      }
    ],
    "cta": {
      "titlePre": "Discuss your regulatory",
      "titleEm": "or licensing matter",
      "sub": "Our team advises on Vietnam’s most complex regulatory approvals and government investigations.",
      "btns": [
        {
          "cls": "btn-gold2",
          "page": "contact",
          "text": "Contact Our Team"
        },
        {
          "cls": "btn-outline",
          "page": "team",
          "text": "Meet the Partners"
        }
      ]
    }
  },
  "labour": {
    "eyebrow": "Chamber Ranked Practice - Vietnam",
    "titleFirst": "Labour &",
    "titleEm": "Employment",
    "sub": "We advise multinational and Vietnamese employers on the full range of labour and employment matters — from employment structuring and HR compliance to union negotiations, mass redundancy, and high-profile executive disputes.",
    "tags": [
      "Employment Contracts",
      "Work Permits",
      "Internal Labor Rules",
      "Union Relations",
      "Mass Redundancy",
      "Executive Disputes"
    ],
    "services": [
      {
        "name": "Employment Contracts",
        "desc": "Drafting and reviewing employment contracts for Vietnamese and foreign employees — including fixed-term and indefinite contracts, probation arrangements, and specialist executive agreements compliant with the Labor Code."
      },
      {
        "name": "Internal Labor Regulations",
        "desc": "Drafting, updating, and negotiating internal labor regulations (nội quy lao động) with trade unions and DOLISA — ensuring compliance with the Labor Code while protecting employer interests."
      },
      {
        "name": "Work Permits & Visas",
        "desc": "Managing work permit and visa applications for expatriate employees — including work permit exemption applications, renewals, and advising on the updated documentation requirements following MOLISA guidance."
      },
      {
        "name": "Disputes & Terminations",
        "desc": "Advising employers on employee disputes, disciplinary proceedings, and terminations — minimising litigation risk and representing clients in wrongful termination claims before Vietnamese labour courts and arbitration councils."
      },
      {
        "name": "Mass Redundancy",
        "desc": "Advising on mass redundancy programmes arising from corporate restructuring, factory closures, and downsizing — including the preparation of labour usage plans, consultation with trade unions, and management of DOLISA notifications."
      },
      {
        "name": "Training & Compliance Audit",
        "desc": "Conducting customised training programmes on labor law compliance, anti-corruption obligations, and HR policy — delivered in English or Vietnamese for management teams and HR departments across all industries. We also conduct intensive employment audit for company and propose changes to comply with labour law."
      }
    ],
    "engagements": [
      {
        "num": "01",
        "tag": "MNC Portfolio — Ongoing Labour Advisory",
        "text": "Contentious and non-contentious labour advice to prominent multinationals operating in Vietnam, including Airbus, Alcon, Daimler, Deutsche Bank, Gap, Ipsen, Johnson & Johnson, Jones & Vining, Levi’s, Marriott, Merck Sharp & Dohme, Microsoft, Werner, and Yggdrasil."
      },
      {
        "num": "02",
        "tag": "C-Level Executive Separations",
        "text": "Advised and negotiated high-profile separation arrangements for C-level executives at prominent multinational corporations operating in Vietnam — managing complex negotiations, severance structures, and post-employment obligations."
      },
      {
        "num": "03",
        "tag": "Mass Redundancy Programmes",
        "text": "Advised numerous multinational clients on mass redundancy programmes arising from corporate restructuring and changes to labour usage plans — managing the full process from union consultation through DOLISA notification and employee settlement."
      },
      {
        "num": "04",
        "tag": "Internal Labor Rules — Trade Union Negotiation",
        "text": "Negotiated and registered internal labor rules with trade unions and DOLISA for multiple large manufacturing clients — managing complex negotiations with union representatives and securing regulatory approval within required timeframes."
      },
      {
        "num": "05",
        "tag": "Compliance & Anti-Corruption Training",
        "text": "Conducted compliance and anti-corruption training workshops for leading MNC companies in Vietnam — including sessions on Vietnam’s Penal Code provisions affecting employees and management, and best practices for HR compliance."
      }
    ],
    "why": [
      {
        "num": "01",
        "title": "Deep MNC Experience",
        "desc": "We have advised some of the world’s leading multinational corporations on Vietnam labour matters — from Airbus and Daimler to Microsoft and Johnson & Johnson — giving us unmatched practical experience across all industries."
      },
      {
        "num": "02",
        "title": "Contentious & Non-Contentious",
        "desc": "Our labour practice covers the full spectrum — from day-to-day HR compliance and contract drafting through complex executive disputes and mass redundancy proceedings before Vietnamese courts and arbitration councils."
      },
      {
        "num": "03",
        "title": "Local Expertise, International Standards",
        "desc": "Our team includes local lawyers with deep expertise in Vietnam’s Labour Code and international lawyers who understand the operational context of multinational employers — providing advice that is both locally accurate and commercially practical."
      }
    ],
    "industries": [
      "Manufacturing & Industrial",
      "Garments & Footwear",
      "Pharmaceuticals & Healthcare",
      "FMCG & Consumer Goods",
      "Financial Services",
      "Technology & Software",
      "Logistics",
      "Hospitality",
      "Automotive"
    ],
    "team": [
      {
        "slug": "diep",
        "name": "Dee (Diep) Hoang",
        "title": "Founder & Partner"
      },
      {
        "slug": "michael",
        "name": "Michael Lee",
        "title": "Partner"
      },
      {
        "slug": "helen",
        "name": "Helen (Trang) Nguyen",
        "title": "Partner"
      }
    ],
    "related": [
      {
        "slug": "privacy",
        "name": "Data Privacy",
        "desc": "Employee data processing, DPIA filing, and privacy training programmes."
      },
      {
        "slug": "disputes",
        "name": "Disputes",
        "desc": "Labour litigation, wrongful termination defence, and mass redundancy disputes."
      },
      {
        "slug": "corporate",
        "name": "Corporate M&A",
        "desc": "Employment due diligence and workforce structuring for M&A transactions."
      }
    ],
    "cta": {
      "titlePre": "Discuss your employment",
      "titleEm": "or labour matter",
      "sub": "Our team advises on Vietnam’s most complex employment and labour disputes across all industries.",
      "btns": [
        {
          "cls": "btn-gold2",
          "page": "contact",
          "text": "Contact Our Team"
        },
        {
          "cls": "btn-outline",
          "page": "team",
          "text": "Meet the Partners"
        }
      ]
    }
  },
  "privacy": {
    "eyebrow": "",
    "titleFirst": "Data",
    "titleEm": "Privacy",
    "sub": "Vietnam’s personal data protection framework has created significant new compliance obligations for businesses. We assist clients in achieving and maintaining full compliance — from DPIA preparation and MPS filing through DPO services and ongoing privacy training.",
    "tags": [
      "DPIA Preparation & Filing",
      "DPO Services",
      "Privacy Policies",
      "OTIA Filings",
      "Privacy Training",
      "Data Processing Agreements"
    ],
    "services": [
      {
        "name": "Compliance Auditing",
        "desc": "We conduct privacy audits to assess a company’s compliance with Vietnam’s personal data protection laws, identifying both vulnerabilities and opportunities for improvement ahead of regulatory scrutiny."
      },
      {
        "name": "Data Protection Officer",
        "desc": "Providing an external Data Protection Officer (DPO) who guides privacy strategy, ensures compliance with Data Privacy Law, and effectively manages data privacy risks on an ongoing basis for your organisation."
      },
      {
        "name": "DPIA Preparation & Filing",
        "desc": "Drafting Data Protection Impact Assessment dossiers and submitting them to the Ministry of Public Security (MPS), Department of Cyber Security and Hi-tech Crime Prevention — including all required forms, notices, and accompanying regulations."
      },
      {
        "name": "Overseas Transfer (OTIA)",
        "desc": "Drafting Overseas Transfer Impact Assessment dossiers for companies transferring personal data outside Vietnam — covering both employee and customer personal data — and managing MPS filing and follow-up."
      },
      {
        "name": "Privacy Training",
        "desc": "Delivering training and awareness courses for all staff on Vietnam’s data privacy laws and best practices — conducted in English or Vietnamese."
      },
      {
        "name": "Privacy Documents & Agreements",
        "desc": "Drafting privacy policies, data processing agreements, consent forms, privacy notices, cookie policies, and standard contractual clauses — tailored to your specific data processing activities and compliant with Data Privacy Law."
      }
    ],
    "engagements": [
      {
        "num": "01",
        "tag": "Fruit of the Loom Vietnam — Full Compliance Programme",
        "text": "Assisted Fruit of the Loom Vietnam in adapting their global privacy policies to local law, drafting and submitting the DPIA dossier and the Outward Transfer Impact Assessment (OTIA) dossier to the MPS, and providing privacy training for employees across the organisation."
      },
      {
        "num": "02",
        "tag": "Henkel — DPIA, OTIA & Regular Training",
        "text": "Assisted Henkel, a leading German industrial adhesive material manufacturer, in conducting regular employee training exercises on Vietnam’s privacy laws, and drafting and submitting both DPIA and OTIA dossiers to the MPS."
      },
      {
        "num": "03",
        "tag": "Phu My Hung — DPIA Filing",
        "text": "Assisted Phu My Hung, one of Vietnam’s largest foreign-invested and premier real estate developers, in preparing and submitting DPIA dossiers (including privacy policies) to the Ministry of Public Security."
      },
      {
        "num": "04",
        "tag": "Jones & Vining — DPIA Submission",
        "text": "Assisted Jones and Vining, a leading American manufacturer of shoe lasts and insoles, in preparing and submitting DPIA dossiers including all required privacy policies to the MPS for their Vietnam operations."
      },
      {
        "num": "05",
        "tag": "Corteva Agriscience Vietnam — Document Review & Translation",
        "text": "Assisted Corteva Agriscience Vietnam in reviewing and translating data protection documents including Marketing Consent & Notice, Visitor Access Forms, Attendance Forms, and Privacy Notices of Corteva Agriscience — ensuring alignment with Vietnamese data protection requirements."
      },
      {
        "num": "06",
        "tag": "Lawrence S. Ting Foundation & School — DPIA Filing",
        "text": "Assisted Lawrence S. Ting Foundation (a Vietnamese local NGO) and Lawrence S. Ting School (a non-profit school founded in 2008) in preparing and submitting DPIA dossiers to the MPS — demonstrating our experience advising non-profit and educational organisations."
      }
    ],
    "why": [
      {
        "num": "01",
        "title": "MPS Filing Experience",
        "desc": "We have prepared and submitted numerous DPIA and OTIA dossiers to the Ministry of Public Security on behalf of multinational and Vietnamese clients — giving us practical knowledge of the filing process, MPS expectations, and common pitfalls."
      },
      {
        "num": "02",
        "title": "Global Policies, Local Compliance",
        "desc": "We specialise in adapting multinational companies’ global privacy policies to Vietnam’s legal requirements — ensuring global consistency while achieving full local compliance with Data Privacy Law."
      },
      {
        "num": "03",
        "title": "Training in EN & VI",
        "desc": "Our data privacy training programmes are delivered by our partners in English or Vietnamese — covering legal requirements and best practices in a format that resonates with both international management teams and local employees."
      }
    ],
    "industries": [
      "Manufacturing & Industrial",
      "Real Estate & Development",
      "FMCG & Consumer Goods",
      "Pharmaceuticals & Agriculture",
      "Technology & Fintech",
      "Financial Services",
      "NGOs & Non-profits",
      "Education"
    ],
    "team": [
      {
        "slug": "diep",
        "name": "Dee (Diep) Hoang",
        "title": "Founder & Partner"
      },
      {
        "slug": "michael",
        "name": "Michael Lee",
        "title": "Partner"
      },
      {
        "slug": "helen",
        "name": "Helen (Trang) Nguyen",
        "title": "Partner"
      }
    ],
    "related": [
      {
        "slug": "labour",
        "name": "Labour & Employment",
        "desc": "Employee data handling, HR privacy compliance, and work permit data obligations."
      },
      {
        "slug": "licensing",
        "name": "Licensing & Regulatory",
        "desc": "Cybersecurity regulation and broader regulatory compliance programmes."
      },
      {
        "slug": "corporate",
        "name": "Corporate M&A",
        "desc": "Data privacy due diligence and post-acquisition compliance alignment."
      }
    ],
    "cta": {
      "titlePre": "Discuss your data privacy",
      "titleEm": "compliance needs",
      "sub": "Our team has submitted numerous DPIA and OTIA dossiers to the MPS on behalf of multinational clients.",
      "btns": [
        {
          "cls": "btn-gold2",
          "page": "contact",
          "text": "Contact Our Team"
        },
        {
          "cls": "btn-outline",
          "page": "toolkits",
          "text": "View Document Toolkits"
        }
      ]
    }
  },
  "realestate": {
    "eyebrow": "",
    "titleFirst": "Real",
    "titleEm": "Estate",
    "sub": "Our team has extensive experience advising foreign developers, investors, manufacturers, and hotel operators on all aspects of Vietnamese real estate and land law — from title due diligence and joint ventures through industrial zone acquisitions and hotel management agreements.",
    "tags": [
      "Land Use Rights",
      "Real Estate JV Agreements",
      "Industrial Zone Acquisitions",
      "Hotel Management Agreements",
      "Title Due Diligence",
      "Construction Contracts"
    ],
    "services": [
      {
        "name": "Land Use Rights Transactions",
        "desc": "Advising on the acquisition, transfer, and leasing of land use rights (LURs) in Vietnam — including title due diligence, LUR registration, and compliance with the Land Law 2024 and its implementing regulations."
      },
      {
        "name": "Real Estate Joint Ventures",
        "desc": "Structuring and documenting real estate joint ventures between foreign developers and Vietnamese partners — including governance frameworks, profit sharing arrangements, exit mechanisms, and project development agreements."
      },
      {
        "name": "Industrial Zone Acquisitions",
        "desc": "Advising manufacturing companies on the acquisition of industrial land and factory facilities in Vietnamese industrial zones — from site identification and due diligence through LUR transfer and factory construction agreements."
      },
      {
        "name": "Hotel Management Agreements",
        "desc": "Advising hotel owners and operators on hotel management agreements, franchise agreements, and technical services agreements — with experience representing both Vietnamese hotel owners and international hotel brands."
      },
      {
        "name": "Leasing & Commercial Property",
        "desc": "Drafting and negotiating office, retail, and commercial leases — including long-term leases, sale and leaseback arrangements, and booking contracts for off-plan residential and resort developments."
      },
      {
        "name": "Construction Contracts",
        "desc": "Advising on construction and development agreements for factory, residential, and commercial projects — including contractor selection, EPC agreements, and dispute avoidance mechanisms."
      }
    ],
    "engagements": [
      {
        "num": "01",
        "tag": "VinaCapital — Ten-Figure Mixed-Use Project",
        "text": "Advised VinaCapital on a ten-figure USD mixed-use real estate project in Central Vietnam, including regulatory advisory, corporate structuring, transactional documentation, and participation in negotiations with potential investors."
      },
      {
        "num": "02",
        "tag": "Kumho E&C — Golf & Residence JV",
        "text": "Negotiated and drafted a joint venture agreement for a golf and residence project in District 9, Ho Chi Minh City, for Kumho E&C. The counterparty was Son Kim Land — a complex bilateral negotiation involving significant land and development rights."
      },
      {
        "num": "03",
        "tag": "Gaw Capital — District 2 Mixed-Use JV",
        "text": "Advised Gaw Capital on a mixed-use real estate joint venture project in District 2, Ho Chi Minh City — involving complex cross-border investment structuring, JV documentation, and land use rights advisory."
      },
      {
        "num": "04",
        "tag": "La Perla Living International — Central Vietnam Resorts",
        "text": "Advised La Perla Living International on several resort and residence joint venture projects in Central Vietnam, including the Bai Tram Resort — assisting with structuring and negotiating the joint venture entity and land acquisition arrangements."
      },
      {
        "num": "05",
        "tag": "Marriott Hotels — Land Due Diligence",
        "text": "Conducted land due diligence and advised on hotel management agreements for several Marriott-branded hotels in Vietnam — reviewing land use right certificates, zoning approvals, and construction permits across multiple properties."
      },
      {
        "num": "06",
        "tag": "Okura Prestige Saigon — Hotel Management Contract",
        "text": "Advised the Vietnamese owner of Okura Prestige Saigon on its hotel management contract with Okura Hotels and Resorts — including key commercial terms, performance standards, termination rights, and owner protection provisions."
      }
    ],
    "why": [
      {
        "num": "01",
        "title": "Developer & Investor Experience",
        "desc": "We have advised some of Vietnam’s largest and most prominent real estate transactions — from ten-figure mixed-use developments to industrial zone acquisitions — representing both foreign developers and Vietnamese landowners."
      },
      {
        "num": "02",
        "title": "Land Law 2024 Expertise",
        "desc": "Following the enactment of the Land Law 2024, we have updated our advisory practice to incorporate the significant changes affecting foreign-invested real estate projects, land use rights certificates, and industrial zone development."
      },
      {
        "num": "03",
        "title": "Manufacturing & Hospitality",
        "desc": "Our real estate practice covers both the industrial and hospitality sectors — advising manufacturers on factory land acquisitions and hotel owners and operators on hotel management agreements with international brands."
      }
    ],
    "industries": [
      "Real Estate & Development",
      "Hospitality & Hotels",
      "Manufacturing & Industrial",
      "Financial Services & Funds",
      "Retail & Commercial Property",
      "Resort & Leisure",
      "Infrastructure"
    ],
    "team": [
      {
        "slug": "diep",
        "name": "Dee (Diep) Hoang",
        "title": "Founder & Partner"
      },
      {
        "slug": "michael",
        "name": "Michael Lee",
        "title": "Partner"
      },
      {
        "slug": "helen",
        "name": "Helen (Trang) Nguyen",
        "title": "Partner"
      }
    ],
    "related": [
      {
        "slug": "corporate",
        "name": "Corporate M&A",
        "desc": "Real estate M&A structuring, share acquisitions of property companies, and FDI structuring."
      },
      {
        "slug": "disputes",
        "name": "Disputes",
        "desc": "Construction disputes, landlord-tenant disputes, and real estate enforcement."
      },
      {
        "slug": "licensing",
        "name": "Licensing & Regulatory",
        "desc": "Zoning approvals, construction permits, and environmental licences."
      }
    ],
    "cta": {
      "titlePre": "Discuss your real estate",
      "titleEm": "or land matter",
      "sub": "Our team advises on Vietnam’s most complex real estate transactions and land use rights matters.",
      "btns": [
        {
          "cls": "btn-gold2",
          "page": "contact",
          "text": "Contact Our Team"
        },
        {
          "cls": "btn-outline",
          "page": "team",
          "text": "Meet the Partners"
        }
      ]
    }
  },
  "disputes": {
    "eyebrow": "Chambers Ranked · VIAC Arbitrators · Vietnam",
    "titleFirst": "Dispute",
    "titleEm": "Resolution",
    "sub": "Dilinh Legal has solid dispute resolution capabilities. Dee (Diep) has extensive commercial litigation experience at different courts in Vietnam while Michael has been an arbitrator with the Vietnam International Arbitration Center (VIAC) since 2012. We represent clients in Vietnamese court proceedings, commercial arbitration, regulatory investigations, and high-profile disputes across labour, tax, environment, and construction.",
    "tags": [
      "Commercial Litigation",
      "Arbitration (VIAC)",
      "Labour Disputes",
      "Regulatory Investigations",
      "Debt Recovery",
      "Construction Disputes"
    ],
    "services": [
      {
        "name": "Commercial Litigation",
        "desc": "Representing clients in civil and commercial disputes before Vietnamese courts at all levels — including contract disputes, debt recovery, shareholder disputes, and enforcement of judgments and arbitral awards."
      },
      {
        "name": "Arbitration",
        "desc": "Advising on and representing clients in domestic and international arbitration proceedings, including VIAC arbitrations. Michael Lee sits on the VIAC panel of arbitrators and has chaired high-value tribunals involving nine-digit USD amounts in controversy."
      },
      {
        "name": "Labour Disputes & Employment Litigation",
        "desc": "Representing employers in wrongful termination claims, mass redundancy disputes, executive separation disputes, and other employment-related litigation before Vietnamese labour courts and arbitration councils."
      },
      {
        "name": "Government Investigations & Regulatory Disputes",
        "desc": "Advising clients facing government investigations, tax audits, customs disputes, environmental enforcement actions, and other regulatory proceedings — providing strategic crisis management advice and representing clients before Vietnamese authorities."
      },
      {
        "name": "Construction Disputes",
        "desc": "Advising on construction contract disputes, including claims arising from delays, defects, variations, and non-payment — across both domestic and international construction projects in Vietnam."
      },
      {
        "name": "Debt Recovery",
        "desc": "Representing multinational banks and corporations in high-value debt recovery matters, including the prosecution of civil lawsuits and enforcement proceedings against defaulting counterparties."
      }
    ],
    "engagements": [
      {
        "num": "01",
        "tag": "Environmental Pollution — Landmark Case",
        "text": "Advised a Taiwanese multinational on one of the most significant environmental pollution incidents in Vietnam. The client was charged with illegally discharging toxic industrial waste into the ocean — a landmark case with major regulatory and reputational dimensions."
      },
      {
        "num": "02",
        "tag": "10-Year Tax Audit — USD 100M Annual Exports",
        "text": "Advised a multinational Taiwanese manufacturer on a high-profile tax audit covering ten years of tax records. The client employed over 5,000 workers across two facilities with yearly exports approaching USD 100 million."
      },
      {
        "num": "03",
        "tag": "VIAC Arbitration — Nine-Digit USD Award",
        "text": "Michael Lee chaired an arbitration tribunal adjudicating a VIAC matter involving a construction dispute in a mining project in Southeast Asia. The amount in controversy was nine digits in USD. The parties accepted the award without appeal — one of the most successful high-value VIAC cases in the centre’s history."
      },
      {
        "num": "04",
        "tag": "Construction Dispute — American Garment Manufacturer",
        "text": "Advised an American garment manufacturer on a critical construction dispute with their general contractor — involving significant financial exposure and complex technical and contractual issues."
      },
      {
        "num": "05",
        "tag": "C-Level Labour Disputes & Mass Redundancy",
        "text": "Advised on numerous high-profile labour disputes involving C-level executive separations and mass redundancy proceedings at large multinational corporations operating in Vietnam."
      },
      {
        "num": "06",
        "tag": "Debt Recovery — Multinational Banks & Corporations",
        "text": "Represented multinational banks and corporations on high-value debt recovery cases, including the prosecution of civil lawsuits before Vietnamese courts."
      }
    ],
    "why": [
      {
        "num": "01",
        "title": "VIAC Arbitrators on Staff",
        "desc": "Michael Lee has been a member of the VIAC panel of arbitrators since May 2012 and has chaired high-value international arbitration tribunals. This gives our clients direct access to arbitration expertise that few Vietnamese boutique firms can match."
      },
      {
        "num": "02",
        "title": "US Litigation Background",
        "desc": "Michael Lee litigated over 200 evidentiary hearings and served as lead trial attorney in 15 jury and bench trials in the United States — bringing a rigorous, evidence-based litigation discipline to every dispute we handle in Vietnam."
      },
      {
        "num": "03",
        "title": "Ranked for Dispute Resolution",
        "desc": "Dilinh was ranked by both Chambers Asia-Pacific and Legal 500 in Dispute Resolution in the 2019 editions — reflecting our track record on some of Vietnam’s most significant disputes and regulatory investigations."
      }
    ],
    "industries": [
      "Manufacturing & Industrial",
      "Garments & Footwear",
      "Financial Services & Banking",
      "Construction & Infrastructure",
      "Pharmaceuticals",
      "Automotive",
      "Logistics & Supply Chain",
      "Real Estate",
      "Mining & Resources",
      "Technology"
    ],
    "team": [
      {
        "slug": "diep",
        "name": "Dee (Diep) Hoang",
        "title": "Founder & Partner"
      },
      {
        "slug": "michael",
        "name": "Michael Lee",
        "title": "Partner"
      },
      {
        "slug": "helen",
        "name": "Helen (Trang) Nguyen",
        "title": "Partner"
      }
    ],
    "related": [
      {
        "slug": "licensing",
        "name": "Licensing & Regulatory",
        "desc": "Government investigations, crisis management, and regulatory proceedings."
      },
      {
        "slug": "labour",
        "name": "Labour & Employment",
        "desc": "Labour disputes, wrongful termination claims, and mass redundancy proceedings."
      },
      {
        "slug": "corporate",
        "name": "Corporate M&A",
        "desc": "Post-acquisition disputes, warranty claims, and shareholder disagreements."
      }
    ],
    "cta": {
      "titlePre": "Resolve your dispute",
      "titleEm": "with confidence",
      "sub": "Our dispute resolution team has handled some of Vietnam’s highest-profile litigation, arbitration, and regulatory matters.",
      "btns": [
        {
          "cls": "btn-gold2",
          "page": "contact",
          "text": "Contact Our Team"
        },
        {
          "cls": "btn-outline",
          "page": "team",
          "text": "Meet the Partners"
        }
      ]
    }
  }
};
